import Multiselect from "vue-multiselect";
import draggable from 'vuedraggable';
import genericConfirm from "../components/generic/confirm.vue"
import genericToggle from "../components/generic/toggle.vue"
import genericHeader from "../components/generic/header.vue"
import genericDefaultParameters from "../components/generic/default-parameters.vue"
import genericModuleSelector from "../components/generic/module-selector.vue"
import genericTable from "../components/generic/table.vue"
import genericTableToolbar from "../components/generic/table-toolbar.vue"
import genericTextMatchType from "../components/generic/text-match-type.vue"
import genericDatePicker from "../components/generic/date-picker.vue"
import genericJobInfo from "../components/generic/job-info.vue"
import genericExplodedBom from "../components/generic/exploded-bom.vue"
import genericHostTextEditor from "../components/generic/host-text-editor.vue"

Vue.component('multiselect', Multiselect);
Vue.component('draggable', draggable);
Vue.component('generic-header', genericHeader);
Vue.component('generic-confirm', genericConfirm);
Vue.component('generic-toggle', genericToggle);
Vue.component('generic-default-parameters', genericDefaultParameters);
Vue.component('generic-module-selector', genericModuleSelector);
Vue.component('generic-table', genericTable);
Vue.component('generic-table-toolbar', genericTableToolbar);
Vue.component('generic-text-match-type', genericTextMatchType);
Vue.component('generic-date-picker', genericDatePicker);
Vue.component('generic-job-info', genericJobInfo);
Vue.component('generic-exploded-bom', genericExplodedBom);
Vue.component('generic-host-text-editor',  genericHostTextEditor);